import { CompanyView } from '@api-proxies';
import {
    IAdditionalFiltersConfig,
    IGenericAdditionalFilters
} from '@shared/additional-filters/additional-filters.config';

export const CONTACTS_FILTER_KEY = 'contacts';

export const CONTACTS_FILTER_CONFIG: IAdditionalFiltersConfig<IAdditionalFiltersContacts> = {
    entityType: 'contacts',

    visibility: {
        company: true,
        includeArchived: true
    },

    transformToFilters: (formValue: any): IAdditionalFiltersContacts => {
        return {
            company: formValue.companies && formValue.companies.length > 0 ? formValue.companies[0] : undefined,
            includeArchived: formValue.includeArchived || undefined
        };
    },

    transformFromFilters: (filters: IAdditionalFiltersContacts): any => {
        return {
            companies: filters?.company ? [filters.company] : [],
            includeArchived: filters?.includeArchived || undefined
        };
    },

    hasFiltersApplied: (filters: IAdditionalFiltersContacts | null): boolean => {
        if (!filters) return false;
        if (filters.company) return true;
        return filters.includeArchived === true;
    }
};

export interface IFilterValueContacts {
    searchText?: string;
    sortBy?: string;
    sortDirection?: string;
    company?: CompanyView;
    includeArchived?: boolean;
}

export interface IAdditionalFiltersContacts extends IGenericAdditionalFilters {
    company?: CompanyView;
    includeArchived?: boolean;
}
